




// import React from "react";

// const CityDestinations = () => {
//   const cities = [
//     // Metro Cities
//     { name: "Delhi", img: "/images/city/dehli.jpeg" },
//     { name: "Mumbai", img: "/images/city/mumbai.webp" },
//     { name: "Bengaluru", img: "/images/city/bangalore.jpg" },
//     { name: "Chennai", img: "/images/city/Chennai.jpg" },
//     { name: "Kolkata", img: "/images/city/kolkata.jpg" },
//     { name: "Hyderabad", img: "/images/city/hyderabad.jpg" },

//     // Tier-2 Cities
//     { name: "Indore", img: "/images/city/indore.jpg" },
//     { name: "Jaipur", img: "/images/city/jaipur.jpg" },
//     { name: "Chandigarh", img: "/images/city/chandigarh.jpeg" },
//     { name: "Lucknow", img: "/images/city/lucknow.jpeg" },
//     { name: "Surat", img: "/images/city/surat.jpg" },
//     { name: "Bhopal", img: "/images/city/bhopal.avif" },

//     { name: "Chennai", img: "/images/city/chennai.jpg" },
// { name: "Delhi", img: "/images/city/delhi.jpg" },
// { name: "Hyderabad", img: "/images/city/hyderabad.jpg" },
// { name: "Jaipur", img: "/images/city/jaipur.jpg" },
// { name: "Kolkata", img: "/images/city/kolkata.jpg" },
// { name: "Lucknow", img: "/images/city/lucknow.jpg" },
// { name: "Mumbai", img: "/images/city/mumbai.jpg" },
// { name: "Nagpur", img: "/images/city/nagpur.jpg" },
// { name: "Pune", img: "/images/city/pune.jpg" },
// { name: "Ahmedabad", img: "/images/city/ahmedabad.jpg" },
// { name: "Bengaluru", img: "/images/city/bengaluru.jpg" }

//   ];

//   return (
//     <section className="city-section">
//       <h2 className="city-title">Our Service Location</h2>

//       <div className="city-scroll">
//         {cities.map((city, index) => (
//           <div className="city-item" key={index}>
//             <img src={city.img} alt={city.name} className="city-img" />
//             <span className="city-name">{city.name}</span>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default CityDestinations;


// import React from "react";

// const CityDestinations = () => {
//   const cities = [
//     { name: "Indore", img: "/images/city/indore.jpg" },
//     { name: "Jaipur", img: "/images/city/jaipur.jpg" },
//     { name: "Chandigarh", img: "/images/city/chandigarh.jpeg" },
//     { name: "Lucknow", img: "/images/city/lucknow.jpeg" },
//     { name: "Surat", img: "/images/city/surat.jpg" },
//     { name: "Bhopal", img: "/images/city/bhopal.avif" },
//     { name: "Chennai", img: "/images/city/chennai.jpg" },
//     { name: "Delhi", img: "/images/city/delhi.jpg" },


// { name: "Chennai", img: "/images/city/chennai.jpg" },
// { name: "Hyderabad", img: "/images/city/hyderabad.jpg" },
// { name: "Jaipur", img: "/images/city/jaipur.jpg" },
// { name: "Kolkata", img: "/images/city/kolkata.jpg" },
// { name: "Lucknow", img: "/images/city/lucknow.jpg" },
// { name: "Mumbai", img: "/images/city/mumbai.jpg" },
// { name: "Nagpur", img: "/images/city/nagpur.jpg" },
// { name: "Pune", img: "/images/city/pune.jpg" },
// { name: "Ahmedabad", img: "/images/city/ahmedabad.jpg" },
// { name: "Bengaluru", img: "/images/city/bengaluru.jpg" },







//     { name: "Rajkot", img: "/images/city/rajkot.jpg" },
// { name: "Ranchi", img: "/images/city/ranchi.jpg" },
// { name: "Salem", img: "/images/city/salem.jpg" },
// { name: "Solapur", img: "/images/city/solapur.jpg" },
// { name: "Surat", img: "/images/city/surat.jpg" },
// { name: "Tirupati", img: "/images/city/tirupati.jpg" },
// { name: "Trichy", img: "/images/city/trichy.jpg" },
// { name: "Trivandrum", img: "/images/city/trivandrum.jpg" },
// { name: "Udaipur", img: "/images/city/udaipur.jpg" },
// { name: "Vadodara", img: "/images/city/vadodara.jpg" },
// { name: "Vijayawada", img: "/images/city/vijayawada.jpg" },
// { name: "Visakhapatnam", img: "/images/city/visakhapatnam.jpg" },
// { name: "Amritsar", img: "/images/city/amritsar.jpg" },
// { name: "Aurangabad", img: "/images/city/aurangabad.jpg" },

// { name: "Bhavnagar", img: "/images/city/bhavnagar.jpg" },
// { name: "Bhopal", img: "/images/city/bhopal.jpg" },
// { name: "Bhubaneswar", img: "/images/city/bhubaneswar.jpg" },
// { name: "Chandigarh", img: "/images/city/chandigarh.jpg" },
// { name: "Coimbatore", img: "/images/city/coimbatore.jpg" },
// { name: "Faridabad", img: "/images/city/faridabad.jpg" },
// { name: "Ghaziabad", img: "/images/city/ghaziabad.jpg" },
// { name: "Gurugram", img: "/images/city/gurugram.jpg" },
// { name: "Guwahati", img: "/images/city/guwahati.jpg" },
// { name: "Gwalior", img: "/images/city/gwalior.jpg" },
// { name: "Hubballi", img: "/images/city/hubballi.jpg" },
// { name: "Indore", img: "/images/city/indore.jpg" },
// { name: "Jamnagar", img: "/images/city/jamnagar.jpg" },
// { name: "Jodhpur", img: "/images/city/jodhpur.jpg" },

// { name: "Kochi", img: "/images/city/kochi.jpg" },
// { name: "Kolhapur", img: "/images/city/kolhapur.jpg" },
// { name: "Kota", img: "/images/city/kota.jpg" },
// { name: "Kozhikode", img: "/images/city/kozhikode.jpg" },
// { name: "Ludhiana", img: "/images/city/ludhiana.jpg" },
// { name: "Madurai", img: "/images/city/madurai.jpg" },
// { name: "Mangaluru", img: "/images/city/mangaluru.jpg" },
// { name: "Mysuru", img: "/images/city/mysuru.jpg" },
// { name: "Nagpur", img: "/images/city/nagpur.jpg" },
// { name: "Nashik", img: "/images/city/nashik.jpg" },
// { name: "Noida", img: "/images/city/noida.jpg" },
// { name: "Patna", img: "/images/city/patna.jpg" }

//   ];

//   return (
//     <section className="city-section">
//       <h2 className="city-title">Our Service Location</h2>

//       <div className="city-scroll">
//         {[...cities, ...cities].map((city, index) => (
//           <div className="city-item" key={index}>
//             <img src={city.img} alt={city.name} className="city-img" />
//             <span className="city-name">{city.name}</span>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default CityDestinations;












import React from "react";

const CityDestinations = () => {
  const cities = [
    { name: "Chandigarh", img: "/images/city/chandigarh.jpeg" },
    { name: "Lucknow", img: "/images/city/lucknow.jpeg" },
    { name: "Surat", img: "/images/city/surat.jpg" },
    { name: "Bhopal", img: "/images/city/bhopal.avif" },
    { name: "Chennai", img: "/images/city/chennai.jpg" },
    { name: "Delhi", img: "/images/city/delhi.jpg" },


{ name: "Chennai", img: "/images/city/chennai.jpg" },
{ name: "Hyderabad", img: "/images/city/hyderabad.jpg" },
{ name: "Jaipur", img: "/images/city/jaipur.jpg" },
{ name: "Kolkata", img: "/images/city/kolkata.jpg" },
{ name: "Lucknow", img: "/images/city/lucknow.jpg" },
{ name: "Mumbai", img: "/images/city/mumbai.jpg" },
{ name: "Nagpur", img: "/images/city/nagpur.jpg" },
{ name: "Pune", img: "/images/city/pune.jpg" },
{ name: "Ahmedabad", img: "/images/city/ahmedabad.jpg" },
{ name: "Bengaluru", img: "/images/city/bengaluru.jpg" },







    { name: "Rajkot", img: "/images/city/rajkot.jpg" },
{ name: "Ranchi", img: "/images/city/ranchi.jpg" },
{ name: "Salem", img: "/images/city/salem.jpg" },
{ name: "Solapur", img: "/images/city/solapur.jpg" },
{ name: "Surat", img: "/images/city/surat.jpg" },
{ name: "Tirupati", img: "/images/city/tirupati.jpg" },
{ name: "Trichy", img: "/images/city/trichy.jpg" },
{ name: "Trivandrum", img: "/images/city/trivandrum.jpg" },
{ name: "Udaipur", img: "/images/city/udaipur.jpg" },
{ name: "Vadodara", img: "/images/city/vadodara.jpg" },
{ name: "Vijayawada", img: "/images/city/vijayawada.jpg" },
{ name: "Visakhapatnam", img: "/images/city/visakhapatnam.jpg" },
{ name: "Amritsar", img: "/images/city/amritsar.jpg" },
{ name: "Aurangabad", img: "/images/city/aurangabad.jpg" },

// { name: "Bhavnagar", img: "/images/city/bhavnagar.jpg" },
{ name: "Bhopal", img: "/images/city/bhopal.jpg" },
{ name: "Bhubaneswar", img: "/images/city/bhubaneswar.jpg" },
{ name: "Chandigarh", img: "/images/city/chandigarh.jpg" },
{ name: "Coimbatore", img: "/images/city/coimbatore.jpg" },
{ name: "Faridabad", img: "/images/city/faridabad.jpg" },
{ name: "Ghaziabad", img: "/images/city/ghaziabad.jpg" },
{ name: "Gurugram", img: "/images/city/gurugram.jpg" },
{ name: "Guwahati", img: "/images/city/guwahati.jpg" },
{ name: "Gwalior", img: "/images/city/gwalior.jpg" },
{ name: "Hubballi", img: "/images/city/hubballi.jpg" },
{ name: "Indore", img: "/images/city/indore.jpg" },
{ name: "Jamnagar", img: "/images/city/jamnagar.jpg" },
{ name: "Jodhpur", img: "/images/city/jodhpur.jpg" },

{ name: "Kochi", img: "/images/city/kochi.jpg" },
{ name: "Kolhapur", img: "/images/city/kolhapur.jpg" },
{ name: "Kota", img: "/images/city/kota.jpg" },
{ name: "Kozhikode", img: "/images/city/kozhikode.jpg" },
{ name: "Ludhiana", img: "/images/city/ludhiana.jpg" },
{ name: "Madurai", img: "/images/city/madurai.jpg" },
{ name: "Mangaluru", img: "/images/city/mangaluru.jpg" },
{ name: "Mysuru", img: "/images/city/mysuru.jpg" },
{ name: "Nagpur", img: "/images/city/nagpur.jpg" },
{ name: "Nashik", img: "/images/city/nashik.jpg" },
{ name: "Noida", img: "/images/city/noida.jpg" },
{ name: "Patna", img: "/images/city/patna.jpg" }
  ];

  return (
    <section className="city-section">
      <h2 className="city-title">Our Service Location</h2>

      {/* ✅ CLIPPING WRAPPER */}
      <div className="city-slider">
        <div className="city-scroll">
          {[...cities, ...cities].map((city, index) => (
            <div className="city-item" key={index}>
              <img src={city.img} alt={city.name} className="city-img" />
              <span className="city-name">{city.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CityDestinations;
